import React from 'react'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import s from './AddressField.scss'


const AddressField = ({ children, isEditable }) => {
  const fieldClassName = cx(s.field, {
    [s.editable]: isEditable,
  })

  return (
    <Box className={fieldClassName} mr="12" mb="12" inline relative>
      <Text className={s.text} color="black">{children}</Text>
    </Box>
  )
}

export default AddressField
